import Moment from 'moment';
// webpack 5 does not bundle moment's dynamic `require('./locale/' + name)` context (the staging bundle shipped
// only `en`, so every date rendered as "Sep 1st (Tue)"); load the locales the app serves explicitly.
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/en-gb';
import { extendMoment } from 'moment-range';
import i18n from './index';
import { DEFAULT_FORMAT_DATE } from '@/constants';

const moment = extendMoment(Moment);
// vue-i18n 11: the locale lives on the global composer (`i18n.locale` was the vue-i18n 8 API and is undefined now,
// which left moment on its default locale)
const locale = i18n.global.locale;

const localeDate = (options = {}) => {
  const { date, format = DEFAULT_FORMAT_DATE } = options;
  const ut = Date.parse(date);

  if (Number.isNaN(ut)) {
    return new Date().toLocaleDateString(locale, format);
  }

  return new Date(ut).toLocaleDateString(locale, format);
};

const datePickerLang = () => {
  const locales = {
    ja: {
      formatLocale: {
        weekdaysMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      },
      yearFormat: 'YYYY年',
      monthBeforeYear: false,
    },
    ko: {
      formatLocale: {
        weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
        monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      },
      yearFormat: 'YYYY년',
      monthBeforeYear: false,
    },
    DEFAULT: {
      monthBeforeYear: true,
      monthFormat: 'MMMM,',
    },
  };

  return locales[locale] || locales.DEFAULT;
};

moment.locale(locale);

export { moment, localeDate, datePickerLang };
